import { ID } from '../types/UtilityTypes'

export interface Tag {
    id: ID,
    name: string,
}